import script from "./AddPositioning.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPositioning.vue?vue&type=script&setup=true&lang=js"

import "./AddPositioning.vue?vue&type=style&index=0&id=adc44634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adc44634"]])

export default __exports__